import { Box, styled } from '@mui/material';

const StyAdornedInput = styled(Box, {
    name: 'StyAdornedInput',
})(({ theme }) => ({
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'inherit',
    height: 'auto',
    backgroundColor: '#d6e3ff',
    borderRadius: '0.3rem',
    margin: '0.1rem 0.3rem 0.1rem 0',
    padding: '0 0.3rem',
    lineHeight: '1.5rem',
    maxWidth: '15vw',
    [theme.breakpoints.down('sm')]: {
        maxWidth: '35vw',
    },
    [theme.breakpoints.down('md')]: {
        maxWidth: '20vw',
    },
}));
export default StyAdornedInput;
